import CustomLink from 'components/TableLink';
import React, { useState } from 'react';
import { DATE_FORMATS, formatDate } from 'utils';
import styles from './index.module.scss';

const InventoryItemBasicDetails = (props) => {
  const { inventoryItem, setShowAddressEdit } = props;
  const {
    objectId,
    name,
    image: { url: image = '' } = {},
    category: { description: categoryName = '' } = {},
    lastInventoryCheckedAt,
    lastInventoryCheckedBy: { objectId: userId = '', full_name: userFullName = ''  } = {},
    inventoryAddress = {},
  } = inventoryItem;
  const [isImageOpen, setIsImageOpen] = useState(false);
  const openFullScreenImage = () => {
    setIsImageOpen(true);
  };

  const closeFullScreenImage = () => {
    setIsImageOpen(false);
  };

  const onClickFullScreenImage = (e) => {
    e.stopPropagation();
  };

  const getImage = () => {
    if (isImageOpen) {
      return (
        <div
          onClick={closeFullScreenImage}
          className={`${styles['lightbox']} ${styles['show']} relative`}
        >
          <img
            onClick={onClickFullScreenImage}
            className={styles['show_image']}
            src={image}
          />
          <span className={styles['close-icon']} onClick={closeFullScreenImage}>
            <i className="fa fa-times-circle"></i>
          </span>
        </div>
      );
    } else {
      return (
        <img
          className={styles['product-image']}
          onClick={openFullScreenImage}
          src={image}
        />
      );
    }
  };


  const inventorySpotCheckedByUser = () => {
    return (
      <div className={styles['category']}>
        Last spot check by: 
        {userId ? <a href={`/users/${userId}`} target='_blank' rel="noreferrer">
          {userFullName || userId}
        </a> : '-'}
      </div>
    );
  };
  
  return (
    <div className={styles['item-sub-container']}>
      {getImage()}
      <div>
        <div className={styles['name']}>
          <CustomLink
            text={name}
            linkTo={`/inventory-items/${objectId}`}
            linkProps={{
              target: '_blank',
            }}
          />
        </div>
        <div className={styles['category']}>
          {categoryName} • {objectId}
        </div>
        <div className={styles['category']}>
            Last spot check at: {lastInventoryCheckedAt ? formatDate(lastInventoryCheckedAt, DATE_FORMATS.MM_DD_YYYY_hh_mm_A) : '-'}
        </div>
        {inventorySpotCheckedByUser()}
        <div onClick={()=>{setShowAddressEdit(true)}} className={styles['inventoryAddress']}>
            Inventory Address: {inventoryAddress?.start?.addressString || 'NA'}-
          {inventoryAddress?.start?.addressString || 'NA'}
          <i className={'fa fa-pencil'} />
        </div>
      </div>
    </div>
  );
};

export default InventoryItemBasicDetails;
